// utils/filterConfig.js
export const buildFilterConfig = (globals, filterState) => {
  const getSelectAllConfig = (dataArray, label) => {
    const hasData = dataArray && dataArray.length > 0;
    return {
      selectAll: hasData,
      disableSearch: !hasData,
      labelledBy: hasData ? "Select" : label,
    };
  };
  const levelConfig = { selectAll: false, disableSearch: false, labelledBy: "Level" };
  const stateConfig = getSelectAllConfig(globals.states, "State");
  const districtConfig = getSelectAllConfig(globals.districts, "District");
  const cityConfig = getSelectAllConfig(globals.cities, "City");
  const branchConfig = getSelectAllConfig(globals.globalBranches, "Branch");
  const examConfig = getSelectAllConfig(globals.exams, "Exam");
  const classConfig = getSelectAllConfig(globals.classes, "Class");
  const sectionConfig = getSelectAllConfig(globals.globalSections, "Section");

  
  return [
    {
      rowId: 0,
      allItems: "All Levels are selected",
      ...levelConfig,
      options: filterState.getLevelArr,
      value: filterState.levelSelectedValue,
      name: "level",
      controlId: "Select Level",
    },
    {
      rowId: 1,
      allItems: "All States are selected",
      ...stateConfig,
      options: filterState.getStateArr,
      value: filterState.statesSelectedValue,
      name: "states",
      controlId: "Select State",
    },
    {
      rowId: 2,
      allItems: "All Districts are selected",
      ...districtConfig,
      options: filterState.getDistricts,
      value: filterState.selectedDistrictsValues,
      name: "districts",
      controlId: "Select Districts",
    },
    {
      rowId: 3,
      allItems: "All Cities are selected",
      ...cityConfig,
      options: filterState.getCities,
      value: filterState.selectedCityValue,
      name: "cities",
      controlId: "Select City",
    },
    {
      rowId: 4,
      allItems: "All Branch are selected",
      ...branchConfig,
      options: filterState.getBranchArr,
      value: filterState.branchSelectedvalue,
      name: "branch",
      controlId: "Select Branch",
    },
    {
      rowId: 5,
      allItems: "All Sections are selected",
      ...sectionConfig,
      options: filterState.getSectionArr,
      value: filterState.sectionSelectedvalue,
      name: "section",
      controlId: "Select Section",
    },
    {
      rowId: 6,
      allItems: "All Exams are selected",
      ...examConfig,
      options: filterState.getExamArr,
      value: filterState.examSelectedvalue,
      name: "exam",
      controlId: "Select Exam",
    },
    {
      rowId: 7,
      allItems: "All Classes are selected",
      ...classConfig,
      options: filterState.getClassArr,
      value: filterState.classSelectedvalue,
      name: "class",
      controlId: "Select Class",
    },
  ];
};